import React from 'react';
import PropTypes from 'prop-types';

// util
import { getMessage, currencyFormatter } from 'util/locale';

import PlantingPlanTextInput from './PlantingPlanTextInput';
import { Icon, TooltipWrapper } from '@tcc/crate';
import { convertPlantingPlanParams } from 'util/parse';
import { isEmeaCountry } from 'constants/countryCodes';

const baseString = 'vra-planting-plan__prices__price-product';
const toolTipClassName = `${baseString}__tooltip`;

const PriceProduct = ({
  accountCountry,
  bagSize,
  currency,
  isReviewScriptStep,
  onChangePriceProduct,
  plantingPlanParams,
  priceProductValidationResult
}) => {
  const label = (
    <div className={`${baseString}__label`}>
      {getMessage('price-product')}&nbsp;
    </div>
  );

  const tooltipContent = (
    <div>
      {getMessage('text__advanced-script__seed-bag', {bagSize})}
      <br/>
      <span className={`${toolTipClassName}__content`}>
        {getMessage('text__advanced-script__seed-bag-subtext', {bagSize})}
      </span>
    </div>
  );

  const { display, displayValue } = convertPlantingPlanParams({
    validationResult: priceProductValidationResult,
    value: plantingPlanParams['price-product'],
    currency
  });

  return (
    <section className={baseString}>
      <PlantingPlanTextInput
        className={`${baseString}__input`}
        dataTestId='price-product-input'
        displayValue={displayValue}
        label={label}
        onChange={onChangePriceProduct}
        onFocus={plantingPlanParams['price-product']}
        placeholder={currencyFormatter(0, currency)}
        validationResult={priceProductValidationResult}
        value={display}>
        <span>
          {getMessage('label-text__seed-cost', { numThousandSeedsPerBag: bagSize/1000 })}
        </span>
      </PlantingPlanTextInput>
      {isReviewScriptStep && isEmeaCountry(accountCountry)
          && <div className={toolTipClassName}>
            <TooltipWrapper
              className={toolTipClassName}
              content={[tooltipContent]}
              placement='bottom'
            >
              <a>
                <Icon className="planting-plan-icon" glyph={Icon.set.INFO_CIRCLE}/>
              </a>
            </TooltipWrapper>
          </div>
      }
    </section>
  );
};
PriceProduct.propTypes = {
  accountCountry: PropTypes.string.isRequired,
  bagSize: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  isReviewScriptStep: PropTypes.bool.isRequired,
  onChangePriceProduct: PropTypes.func.isRequired,
  plantingPlanParams: PropTypes.object.isRequired,
  priceProductValidationResult: PropTypes.object
};
export default PriceProduct;
